<template>
  <div class="animated fadeIn" v-if="!loading">
    <basic-heading title="Receiving">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <b-row class="px-0 m-0 bg-light my-3">
      <b-col
        v-for="(indicator, index) in indicators"
        :class="`px-${index === 1 ? 3 : 0}`"
        :key="index"
      >
        <indicator-tile
          :text="indicator.text"
          :indicator_key="indicator.indicator_key"
          :faIcon="indicator.faIcon"
          :variant="indicator.variant"
        />
      </b-col>
    </b-row>
    <project-receive-server-table :collection="collection" />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import ProjectReceiveServerTable from "@/components/lab/sample/ProjectReceiveServerTable";
import IndicatorTile from "@/components/shared/IndicatorTile";
import { mapGetters } from "vuex";
import { receive_indicators } from "@/shared/_indicators";
import SubmissionCollection from "@/collections/lab/SubmissionCollection";
export default {
  name: "ReceiveIndex",
  components: {
    IndicatorTile,
    ProjectReceiveServerTable,
    BasicHeading,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      indicators: receive_indicators,
      collection: new SubmissionCollection(),
    };
  },
  computed: {
    ...mapGetters(["receiveStore"]),
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/samples",
            title: "To All samples",
            variant: "success",
          },
          {
            icon: "fa-scanner",
            linkto: "/samples/receive/batch/scan",
            title: "Scan Samples",
            variant: "primary",
          }
        ],
      };
    },
  },
  created() {
    this.loading = true;
    let filter = this.collection.getFilter();
    filter.filterNull("samples.receiving_id");
    filter.cacheStaticFilters();
    this.loading = false;
  },
};
</script>
